import axios from 'axios';
import { config, API_URL } from '../../../config/config';

const getAllMasterEntry = async () => {
	const response = await axios.post(`${API_URL}/master-entry/get-master-entry`, {}, config);
	return response.data;
};

const masterService = {
	getAllMasterEntry,
};
export default masterService;
